export default __webpack_public_path__ + "static/media/sort_down_deactive.284b28d9.svg";